import { Status } from '@systemeio/components'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'

export const StatusCell = ({ isActive }: { isActive: boolean }) => {
  const { t } = useLocoTranslation()

  return (
    <Status color={isActive ? 'active' : 'inactive'} size="md">
      {isActive ? t('global.active') : t('global.inactive')}
    </Status>
  )
}
